import { Button } from '@design-system/components/button/button';
import { Controller } from 'react-hook-form';
import { Typography } from '@design-system/components/typography/typography';
import { Switch, Breadcrumbs } from '@mui/material';
import { EditWorkoutVM } from '../view-models/workoutEdit.viewModel';
import { Schedule } from './Schedule';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';

export const Header = ({
  dispatch,
  control,
  currentBreadcrumb,
  watch,
  isNewForm,
  publishAction,
  readonly,
  errorMessage,
}: Pick<
  EditWorkoutVM,
  | 'dispatch'
  | 'control'
  | 'currentBreadcrumb'
  | 'watch'
  | 'isNewForm'
  | 'publishAction'
  | 'readonly'
  | 'errorMessage'
>) => (
  <div>
    <div className="w-full p-5">
      <Breadcrumbs aria-label="breadcrumb">
        <Typography
          className="cursor-pointer"
          onClick={() => dispatch('navigateToWorkouts')}
        >
          Workouts
        </Typography>
        <Typography color="B-100">{currentBreadcrumb}</Typography>
      </Breadcrumbs>
    </div>
    <div className="flex flex-col md:flex-row flex-wrap items-center gap-4">
      {!errorMessage ? null : (
        <div className="flex gap-2 bg-[#FFE2E2] pl-4 py-3.5 pr-2 rounded-[10px]">
          <FontAwesomeIcon
            icon={faExclamationCircle}
            className="text-[#DA0000]"
          />
          <Typography className="flex w-full">{errorMessage}</Typography>
        </div>
      )}
      <div className="flex flex-wrap items-center md:self-end gap-4 ml-auto">
        <div className="pl-4 md:pl-0 flex items-center">
          <Typography>Free sample</Typography>
          <Controller
            name={'freeSample'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <Switch
                checked={value}
                onChange={onChange}
                data-testid="freeSample"
                disabled={readonly}
              />
            )}
          />
        </div>
        <Button
          color="neutral"
          variant="text"
          onClick={() => dispatch('save')}
          disabled={readonly}
        >
          {isNewForm ? 'Save as draft' : 'Save'}
        </Button>
        <Schedule dispatch={dispatch} watch={watch} disabled={readonly} />
        <Button
          color="neutral"
          onClick={publishAction.onClick}
          disabled={readonly || publishAction.disabled}
        >
          {publishAction.label}
        </Button>
      </div>
    </div>
  </div>
);
